import React, { Component } from 'react';
import { connect } from 'react-redux';
import './UploadBadge.scss';
import { Storage } from '../../../shared/services/aws';
import LoadingButton from '../../../shared/ui/LoadingButton';
import uuidv4 from 'uuid/v4';

class UploadBadge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      badgeUrl: this.props.badgePhoto ? this.getS3Link(this.props.badgePhoto) : null,
      badgeKey: null,
     };
  }

  inputFile;

  // ----------------------
  // Methods
  // ----------------------

  getS3Link(imageUrl) {
    Storage.get(imageUrl)
      .then(result => {
        this.setState({
          badgeUrl: result
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  triggerUpload() {
    this.inputFile.click();
  }

  uploadFile(event) {
    const file = event.target.files[0];
    let fileExtension = file.type.split('/')[1];
    let fileName = uuidv4() + '.' + fileExtension;
    const s3Key = `${this.props.userContext.departmentGuid}/badges/${fileName}`;

    this.setState({
      isLoading: true
    });

    Storage.put(s3Key, file, {contentType: file.type})
      .then((result) => {
        this.setState({
          isLoading: false,
          badgeKey: result.key
        });

        this.getS3Link(result.key);
        this.updatePhoto();
      })
      .catch((error) => {
        this.setState({
            isLoading: false
        });
        console.log(`[AttachmentForm] uploadFile() error: ${JSON.stringify(error)}`);
      });
  }

  updatePhoto() {
    this.props.onSaveBadge(this.state.badgeKey);
  }

  render() {
    return (
      <div className="upload-badge">
        <input type="file" ref={(ref) => this.inputFile = ref} onChange={e => this.uploadFile(e)}/>

        {this.props.question &&
          <label className="photo-label">
            Photo
          </label>
        }

        <div className="img-container">
            {this.state.badgeUrl &&
              <img className="image" src={this.state.badgeUrl} />
            }
        </div>

        <div className="upload-btn">
            <LoadingButton
              primary
              icon="fa fa-upload"
              text="Upload Photo"
              type="button"
              isLoading={this.state.isLoading}
              onClick={() => this.triggerUpload()}
            />
        </div>
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps)(UploadBadge);
